import { FormError } from '@/ui/form/form.component';
import { object, string } from 'yup';

export const customerSchema = object({
  username: string().typeError(FormError.required).required(FormError.required),
  status: string().typeError(FormError.required).required(FormError.required),
});
